// Shared footer for all pages in the Chrona Pro configurator.
// `target="_blank"` so the user never loses the form they're mid-way
// through; `rel="noopener"` (not "noreferrer") so chronabio.ai marketing
// analytics still see the referrer — intentional.

import { Link } from 'react-router-dom'

const TERMS_URL = 'https://chronabio.ai/terms'
const PRIVACY_URL = 'https://chronabio.ai/privacy'
const SUPPORT_URL = 'https://chronabio.ai/support'

interface Props {
  // Center under a full-width page, or sit inline inside a card footer.
  variant?: 'page' | 'inline'
}

export function TermsPrivacyFooter({ variant = 'page' }: Props) {
  const wrapClass =
    variant === 'page'
      ? 'text-xs text-slate-500 text-center py-6'
      : 'text-[11px] text-slate-500 text-center'
  const sep = <span className="mx-2 text-slate-300">·</span>
  return (
    <div className={wrapClass}>
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noopener"
        className="hover:text-slate-700"
      >
        Terms
      </a>
      {sep}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener"
        className="hover:text-slate-700"
      >
        Privacy
      </a>
      {sep}
      <Link to="/pricing" className="hover:text-slate-700">
        Pricing
      </Link>
      {sep}
      <a
        href={SUPPORT_URL}
        target="_blank"
        rel="noopener"
        className="hover:text-slate-700"
      >
        Support
      </a>
    </div>
  )
}
